module.exports = __webpack_public_path__ + "img/vimeo-source.bd9b04d5.svg";